<section class="become-our-partner-video-partner-promise">
  <div class="box">
    <div class="box-left">
      <h3 class="box-left__title"
        ><span>{{ 'BECOME_OUR_PARTNER.PARTNER_PROMISE.HEADING' | translate }}</span></h3
      >
      <div class="box-left__detail"
        ><span>{{ 'BECOME_OUR_PARTNER.PARTNER_PROMISE.DETAIL' | translate }}</span></div
      >
      <div class="box-left__link"
        ><a
          [href]="'https://flowaccount.com/' + this.translate.currentLang + '/functions/accounting'"
          target="_blank"
          rel="noopener noreferrer"
          class="hover-text"
          ><span>{{ 'BECOME_OUR_PARTNER.PARTNER_PROMISE.LINK' | translate }}</span></a
        >&nbsp;<i class="fas fa-angle-right"></i
      ></div>
    </div>
    <div class="box-right">
      <div class="box-right__img" (click)="linkVideo('dz8Y3ofc5UU')">
        <div class="img-cover"></div>
        <picture>
          <source
            srcset="https://flowaccountcdn.com/new_landing/image/home/Thumbnail-Partner-2024.webp"
            type="image/webp"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/home/Thumbnail-Partner-2024.jpg"
            class="img-layout"
            [alt]="'BECOME_OUR_PARTNER.PARTNER_PROMISE.HEADING' | translate"
            loading="lazy"
          />
        </picture>
        <div class="img-icon">
          <picture>
            <img
              src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
              class="img-icon__button"
              alt="icon-play-video"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
</section>
